import React, { useState } from 'react';

const moods = [
  {
    emoji: '✨',
    text: 'Main Character Energy',
    mood: 'main_character_energy',
    description: 'Ready to be the protagonist'
  },
  {
    emoji: '🌧️',
    text: 'Cozy Rainy Day',
    mood: 'cozy_rainy_day',
    description: 'Perfect for staying in'
  },
  {
    emoji: '🌙',
    text: 'Late Night Thoughts',
    mood: 'late_night_thoughts',
    description: 'Deep and contemplative'
  },
  {
    emoji: '😈',
    text: 'Villain Origin Story',
    mood: 'villain_origin_story',
    description: 'Embracing the dark side'
  },
  {
    emoji: '🌅',
    text: 'Sunday Reflection',
    mood: 'sunday_reflection',
    description: 'Time for introspection'
  },
  {
    emoji: '🎭',
    text: 'Chaotic Good',
    mood: 'chaotic_good',
    description: 'Breaking rules for the right reasons'
  },
  {
    emoji: '✈️',
    text: 'Wanderlust',
    mood: 'wanderlust',
    description: 'Yearning for adventure'
  },
  {
    emoji: '🎨',
    text: 'Creative Flow',
    mood: 'creative_flow',
    description: 'Spark your imagination'
  },
  {
    emoji: '💪',
    text: 'Power Moves',
    mood: 'power_moves',
    description: 'Taking charge'
  },
  {
    emoji: '💝',
    text: 'Hopeless Romantic',
    mood: 'hopeless_romantic',
    description: 'In love with love'
  },
  {
    emoji: '🔮',
    text: 'Mystical Vibes',
    mood: 'mystical_vibes',
    description: 'Magic and mystery'
  },
  {
    emoji: '🌀',
    text: 'Plot Twist',
    mood: 'plot_twist',
    description: 'Ready for surprises'
  },
  {
    emoji: '🌊',
    text: 'Emotional Waves',
    mood: 'emotional_waves',
    description: 'Feeling all the feels'
  },
  {
    emoji: '🧠',
    text: 'Focused Mode',
    mood: 'focused_mode',
    description: 'Ready to learn'
  },
  {
    emoji: '🦄',
    text: 'Whimsical Wonder',
    mood: 'whimsical_wonder',
    description: 'Lost in magic'
  }
];

function MoodSelector({ selectedMood, onMoodSelect }) {
  const handleMoodSelect = (mood) => {
    onMoodSelect(mood);
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
      {moods.map((mood) => (
        <button
          key={mood.mood}
          onClick={() => handleMoodSelect(mood)}
          className={`p-3 sm:p-4 rounded-lg border-2 transition-all ${
            selectedMood?.mood === mood.mood
              ? 'border-blue-500 bg-blue-50'
              : 'border-gray-200 hover:border-blue-200'
          }`}
        >
          <div className="text-xl sm:text-2xl mb-1 sm:mb-2">{mood.emoji}</div>
          <div className="font-medium text-sm sm:text-base">{mood.text}</div>
          <div className="text-xs sm:text-sm text-gray-600">{mood.description}</div>
        </button>
      ))}
    </div>
  );
}

export default MoodSelector; 